import { AdminListUserComplaintFilter, } from '../../graphql/API';
import { adminListUserComplaintCount } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminListUserComplaintCountApi = async (
  filter: AdminListUserComplaintFilter,
): Promise<Record<string, number>> => {
  const result = await executeGql<string>(adminListUserComplaintCount, { filter });
  return JSON.parse(processGqlResult<string>('adminListUserComplaintCount', result));
};
